// Words for /list-your-venue and /list-your-venue/not-a-fit (venue-search
// VS1.2). Approved by Braeden 2026-11-02. The statements themselves are a
// versioned file: src/content/hostRequirements/.

const copy = {
  requirements: {
    title: 'List your venue on Yedding',
    intro: 'Every venue on Yedding meets these 5 requirements. Please answer each one.',
    yes: 'Yes',
    no: 'No',
    continue: 'Continue',
    answerAll: 'Answer all 5 to continue.',
    questions: 'Questions? Email',
    account: 'Create a free account to start your listing.',
    createAccount: 'Create account',
    signIn: 'Sign in'
  },
  notAFit: {
    title: 'We cannot list this venue',
    intro: 'Every venue on Yedding must meet all 5 requirements. You answered "No" to:',
    // Shown instead of `intro` when the page opens with no answers (a direct link).
    introNoAnswers: 'Every venue on Yedding must meet all 5 requirements.',
    why: 'These rules protect bookers and hosts. Bookers choose their own vendors, and every event must be allowed at the property.',
    contact: 'If something changes, or if you have a question, email',
    back: 'Back to the requirements'
  },
  supportEmail: 'support@yedding.com'
};

export default copy;
